import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory, useLocation } from "react-router-dom";

import { parse } from "date-fns";

import theme from "../../index.scss";
import ComponentWrapper from "../Dashboard/ComponentWrapper";
import SubmitButton from "../UIComponents/SubmitButton";

import getDaysAgo from "../../lib/getDaysAgo";

import ReactECharts from "echarts-for-react";

const TriggerDetailsChart = ({ error, topSymptoms, data, retry }) => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();

  const history = useHistory();
  const location = useLocation();

  // Access the parameters from location.state if available,
  // otherwise provide default values
  const triggerType = location.state?.triggerType;
  const fromTriggerDetailsChart =
    location.state?.fromTriggerDetailsChart || false;
  const days = location.state?.days || 7;

  const filteredData = data
    ?.filter(
      (obj) =>
        obj.category == "SDOH" &&
        (obj.subcategory == `${triggerType.toLowerCase()}` ||
          obj.subcategory == `${triggerType}`)
    )
    .filter(
      (obj) =>
        parse(obj.symptom_date.slice(0, 10), "yyyy-MM-dd", new Date()) >
        getDaysAgo(days)
    );
  const count = {};
  filteredData.forEach((item) => {
    const element = item.factor;
    count[element] = (count[element] || 0) + 1;
  });
  const result = Object.entries(count).map(([name, value]) => ({
    name,
    value,
  }));
  const sorted = result.sort((a, b) => b.value - a.value);

  const option = {
    title: {
      text: `${t(`triggercategory.${triggerType}`)} Details`,
      left: "center",
      textStyle: {
        fontSize: 24,
        color: dark ? theme.darkModeText : theme.black,
      },
    },
    tooltip: {
      trigger: "item",
    },
    xAxis: {
      type: "value",
      axisLabel: {
        fontSize: 16, // Change the font size here
        color: dark ? theme.darkModeText : theme.black,
      },
    },
    grid: {
      left: "5%", // Adjust the left padding here
      containLabel: true,
    },
    yAxis: {
      type: "category",
      axisLabel: {
        fontSize: 16, // Change the font size here
        color: dark ? theme.darkModeText : theme.black,
      },
      data: sorted.map((item) => item.name).reverse(), // reverse to show top elements at top
    },
    series: [
      {
        data: sorted.map((item) => item.value).reverse(),
        type: "bar",
      },
    ],
  };
  return (
    <>
      {error && (
        <ComponentWrapper>
          {t("charts.error.0")}
          <SubmitButton onClick={retry}>
            {t("charts.error.1")}
          </SubmitButton>
        </ComponentWrapper>
      )}

      <ComponentWrapper>
        <ReactECharts option={option} style={{ minHeight: "40vh" }} />
      </ComponentWrapper>

      <SubmitButton
        onClick={
          !fromTriggerDetailsChart
            ? () => history.push("/")
            : () => history.push({ pathname: "/charts", state: { days: days } })
        }
      >
        {t("common.go_back")}
      </SubmitButton>
    </>
  );
};

export default TriggerDetailsChart;